import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {getSessionObject} from '../../../../common/Session.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import withRouter from '../../../organisms/withRouter.js';
import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import MenuItem from '@mui/material/MenuItem';
import {Field} from 'redux-form';
import PaperPart from '../../../atoms/PaperPart.js';

import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_KASYO_LIST.name,
    href: GMN_PATH.TSTK_KASYO_LIST},
  {gmnName: GMN.TSTK_KOTEI_LIST.name, href: ''},
];

const styles = (theme) => ({

});

// 一覧
const tstkKoTeiViews = [
  {binding: 'tstkType', header: '調査・点検区分', dataType: 'String', width: 150, readOnly: true},
  {binding: 'tstkKotei', header: '工程', dataType: 'String', width: 220, readOnly: true},
  {binding: 'hakoUserName', header: '発行者', dataType: 'String', width: 150, readOnly: true},
  {binding: 'hakoDate', header: '発行日時', dataType: 'String', width: 180, readOnly: true},
  {binding: 'hiketuComment', header: '否決コメント', dataType: 'String', width: 180, readOnly: true},

];

/**
 * 調査・点検工程照会画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // パラメータ取得
    const storage = getSessionObject(GMN.TSTK_KOTEI_LIST.id);
    let tstkTypeParam = storage['tstkType'];
    let supplyPointNoParam =storage['supplyPointNo'];
    let customerNameParam = storage['customerName'];
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
      seiHeaderDate: {},
      tstkTypeParam: tstkTypeParam,
      supplyPointNoParam: supplyPointNoParam,
      customerNameParam: customerNameParam,
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        this.getInitializeData();
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    if (this.gridRef && this.gridRef.current) {
      // this.getInitializeData();
    }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const dataKen =[

    ];

    this.gridRef.current.setItemsSource(dataKen);
    return true;
  };

  /**
   * 画面項目初期化
   * @param {object} initItems
   */
  initializeItems = (initItems) => {
    const gmnItems = Object.assign(
        tstkKoTeiViews,
    );
    for (const key of Object.keys(gmnItems)) {
      const item = gmnItems[key];
      if (Object.hasOwn(item, 'binding')) {
        initItems[item.binding] = null;
      }
    }
  };

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let initItems = {};
    this.initializeItems(initItems);
    let henkoJohomaeList = [];
    let headerData = {};
    if (this.state.tstkTypeParam === '1') {
      henkoJohomaeList = [
        {tstkType: '調査', tstkKotei: '未着手', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '調査', tstkKotei: '調査中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '調査', tstkKotei: '調査済', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '調査', tstkKotei: '報告中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '調査', tstkKotei: '調査済', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: '否決された。'},
        {tstkType: '調査', tstkKotei: '報告中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '調査', tstkKotei: '完了', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},

        {tstkType: '再調査', tstkKotei: '未着手', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '再調査', tstkKotei: '調査中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '再調査', tstkKotei: '調査済', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '再調査', tstkKotei: '報告中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '再調査', tstkKotei: '完了', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
      ];
    } else {
      henkoJohomaeList = [
        {tstkType: '点検', tstkKotei: '未着手', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '点検中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '点検済', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '報告中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '点検済', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: '否決された。'},
        {tstkType: '点検', tstkKotei: '報告中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '確認中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '点検済', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: '否決された。'},
        {tstkType: '点検', tstkKotei: '報告中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},

        {tstkType: '点検', tstkKotei: '確認中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '承認中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '確認中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: '否決された。'},
        {tstkType: '点検', tstkKotei: '承認中', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},
        {tstkType: '点検', tstkKotei: '完了', hakoDate: '2026/8/9 12:31 23', hakoUserName: '田中  一郎', hiketuComment: ''},

      ];
    }

    headerData = {customerName: '', supplyPointNo: '', tstkType: ''};
    headerData['supplyPointNo']=this.state.supplyPointNoParam;
    headerData['tstkType']=this.state.tstkTypeParam;
    headerData['customerName']=this.state.customerNameParam;

    // データを画面に設定
    this.props.doSetInitValues(headerData);

    if (this.gridRef.current) {
    // 変更前リストデータを画面に設定
      this.gridRef.current.setItemsSource(henkoJohomaeList);
    }
    // for (const key of Object.keys(initItems)) {
    //   if (Object.hasOwn(headerData, key)) {
    //     initItems[key] = headerData[key];
    //   }
    // }
    // this.setState({
    //   seiHeaderData: headerData,
    // });
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}
      align={view.align}
      cssClass={view.cssClass}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
  };

  /**
   * 県一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto', marginTop: '0px', marginLeft: '5px'},
      // isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
    };

    let viewElems = [];
    if (tstkKoTeiViews) {
      for (const view of tstkKoTeiViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }


  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="customerName" item xs={12} sm={2}>
            <Field
              id="customerName"
              name="customerName"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="お客さま名"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: true,
              }}
            >
            </Field>
          </Grid>
          <Grid key="supplyPointNo" item xs={12} sm={2}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="供給地点特定番号"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: true,
              }}
            >
            </Field>
          </Grid>

          <Grid key="tstkType" item xs={12} sm={2}>
            <Field
              id="tstkType"
              name="tstkType"
              component={renderSelect}
              className="fields"
              label="調査・点検"
              fullWidth
              type="text"
              required={false}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'調査'}</MenuItem>
              <MenuItem value={2}>{'点検'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      // handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    // const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          // footerBtn={footerBtn}
        >
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <PaperPart>
            {this.renderCondition()}
          </PaperPart>
          {/* <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid> */}
          {/* <PaperPart>
            {this.renderCondition()}
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart> */}
          <div style={{marginBottom: '20px'}} />
          {/* <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} /> */}
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
            spacing={1}
            direction={'row'}
          >
            {this.renderTable()}
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

